document.addEventListener('DOMContentLoaded', function () {

    let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
    console.log(items)
    items.forEach(item => {
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
    
    });
  
  // Accordion toggle
  document.querySelectorAll('.grid__item .accordion .summary').forEach(function (summary) {
    summary.addEventListener('click', function () {
      this.parentElement.classList.toggle('active');
    });
  });

  // Hide all .readmore-text initially
  document.querySelectorAll('.readmore-text').forEach(function (el) {
    el.style.display = 'none';

    // Create "Read More" button
    const readMoreBtn = document.createElement('a');
    readMoreBtn.textContent = 'Read More';
    readMoreBtn.className = 'readMore';
    readMoreBtn.style.cursor = 'pointer';
    readMoreBtn.style.marginBottom = '12px';
    readMoreBtn.style.display = 'inline-block';

    // Insert after the .readmore-text element
    el.parentNode.insertBefore(readMoreBtn, el.nextSibling);

    // Toggle on click
    readMoreBtn.addEventListener('click', function (e) {
      e.preventDefault();

      if (el.style.display === 'none') {

        el.style.display = 'block';
        readMoreBtn.textContent = 'Read Less';
        readMoreBtn.classList.add('less');
      } else {
        el.style.display = 'none';
        readMoreBtn.textContent = 'Read More';
         readMoreBtn.classList.remove('less');
      }
    });
  });
});